import { Box } from '@mui/material';

const Datasources = () => {
  return (
    <Box m="20px">
      {/* HEADER */}
      <Box display="flex" justifyContent="space-between" alignItems="center">
        <h3>Datasources</h3>
      </Box>
    </Box>
  );
};

export default Datasources;
